import { render, staticRenderFns } from "./TravelAdd.vue?vue&type=template&id=6fbef058&"
import script from "./TravelAdd.vue?vue&type=script&lang=js&"
export * from "./TravelAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports